import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareSurveysQuery } from '@composables/middleware/surveys-query.hook'

import { toIdValue } from '@helpers/route'

import { defineNuxtRouteMiddleware } from '#app'

/** `/disciplines/{id}/surveys` — the surveys table limited to the discipline. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const disciplineId = toIdValue(to.params.id)
  if (!disciplineId) return

  return useMiddlewareSurveysQuery(to, disciplineId)
})
